"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spacing = {
    compact: {
        none: 0,
        xxs: 4,
        xs: 8,
        s: 12,
        m: 16,
        l: 24,
        xl: 32,
        xxl: 48,
    },
    regular: {
        none: 0,
        xxs: 4,
        xs: 8,
        s: 16,
        m: 24,
        l: 32,
        xl: 48,
        xxl: 72,
    },
    large: {
        none: 0,
        xxs: 4,
        xs: 8,
        s: 24,
        m: 32,
        l: 40,
        xl: 64,
        xxl: 96,
    },
};
exports.default = spacing;
//# sourceMappingURL=spacing.js.map